import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface ScoreCardProps {
  className?: string;
  score: number | null;
}
function ScoreCard({ className, score }: ScoreCardProps) {
  const { t } = useTranslation();

  return (
    <div
      className={twMerge(
        className,
        "flex flex-col gap-2 rounded-b-lg border-t-2 border-cyan-600 px-4 py-3 shadow",
      )}
    >
      <div className="text-cyan-600">{t("score")}</div>
      <div className="text-3xl font-bold text-cool-gray-900">
        {score ?? "--"} <span className="text-lg">{t("points")}</span>
      </div>
    </div>
  );
}

export default ScoreCard;
